
class KeepCache {
    constructor() {
        if (typeof window !== 'undefined') {
            console.log('[KC] Keep chache built with window');
            try {
                this.localStorage = window.localStorage;
            } catch (e) {
                console.error('[KC] Error accessing localstorage: ', e);
                this.localStorage = null;
            }
            if (this.localStorage) {
                let dateEnabled = Date.now();
                try {
                    this.localStorage.setItem('fPopCache', `${dateEnabled}`);
                } catch (e) {
                    console.error('[KC] Error setting item to localStorage');
                } finally {
                    let enabledAt = this.localStorage.getItem('fPopCache');
                    if (parseInt(`${dateEnabled}`) === dateEnabled) {
                        console.log('[KC] Date enabled matched, localStorage is enabled');
                    } else {
                        console.error(`[KC] Date enabled mismatch, expected ${dateEnabled} but got: `, enabledAt);
                    }
                }
            }
        }
    }

    saveItem(itemName, valueString, validFor = 1000 * 60 * 60) {
        if (!this.localStorage) {
            return;
        }
        // ValidFor 5 minutes
        this.localStorage.setItem(itemName, valueString);
        this.localStorage.setItem(`${itemName}.validFor`, `${Date.now() + validFor}`);
    }

    getItem(itemName) {
        if (!this.localStorage) {
            return null;
        }
        const exists = this.localStorage.getItem(`${itemName}.validFor`);
        if (!exists) {
            // Make sure it doesn't exist anymore
            this.localStorage.removeItem(`${itemName}`);
            return null;
        }
        else if (parseInt(exists) >= Date.now()) {
            // If cache is still valid, return value
            return { value: this.localStorage.getItem(`${itemName}`), validFor: parseInt(exists) };
        } else {
            // Cache is no longer valid
            this.localStorage.removeItem(`${itemName}.validFor`);
            this.localStorage.removeItem(`${itemName}`);
            return null;
        }
    }
}

export default (() => {
    const keepCache = new KeepCache();
    return keepCache;
})()